import React from 'react';
import { useTranslation } from 'react-i18next';
import { SxProps, Theme } from '@mui/material/styles';
import { CustomButton, CustomCircularProgress, LoadingContainer } from './OptimizerTable.styles';
interface OptimizerButtonProps {
  isOptimizerButtonDisabled: boolean;
  isOptimizerButtonLoading: boolean;
  handleOptimizerButtonClick: () => void;
  endIcon?: React.ReactNode;
  text: string;
  isOptimizeLoading?: boolean;
  sx?: SxProps<Theme>;
}
const OptimizerButton = ({
  isOptimizerButtonDisabled,
  isOptimizerButtonLoading,
  handleOptimizerButtonClick,
  endIcon,
  text,
  isOptimizeLoading,
  sx,
}: OptimizerButtonProps) => {
  const { t } = useTranslation('optimizer');
  const isLoading = isOptimizeLoading !== undefined ? isOptimizeLoading : isOptimizerButtonLoading;
  return (
    <CustomButton
      variant="contained"
      onClick={handleOptimizerButtonClick}
      disabled={isOptimizerButtonDisabled || isLoading}
      sx={sx}
    >
      {isLoading ? (
        <LoadingContainer>
          <CustomCircularProgress size={20} />
          {t('table.processing')}
        </LoadingContainer>
      ) : (
        <>
          {text}
          {endIcon && endIcon}
        </>
      )}
    </CustomButton>
  );
};
export default OptimizerButton;
